import dayjs from 'dayjs'

export const date = (value: string | number) => {
  if (!value) return ''
  return dayjs(value).format('DD/MM/YYYY')
}

export const dateTime = (value: string | number) => {
  if (!value) return ''
  return dayjs(value).format('DD/MM/YYYY HH:mm:ss')
}
